import { Component, Inject, OnInit } from '@angular/core';
import { ApiUrls } from '../../apiRouts';
import { MainService } from '../../service/main.service';
import { Location } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SharedModule } from '../../shared/shared.module';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-allmemberlist',
  templateUrl: './allmemberlist.component.html',
  styleUrl: './allmemberlist.component.scss'
})
export class AllmemberlistComponent implements OnInit {
  baseUrl = environment.imageURL;
  MemberList: any = [];
  originalMemberListData: any[] = [];
  sub2 = new Subscription;
  memberList1: any;
  dataDistrictList: any = [];
  selectedDistrictId: any = 0;

  constructor(
    private _bottomSheet: MatBottomSheet,
    private location: Location,
    private mainService: MainService
  ) {
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {

      this.MemberList = this.originalMemberListData.filter((user: any) => {
        const villageTrimmed = user.village_id.toString().trim().toLowerCase();
        const resVillageTrimmed = res.village_id.toString().trim().toLowerCase();
        const bloodGroupMatch = !res.blood_group || user.blood_group.toLowerCase() === res.blood_group.toLowerCase();
        const villageNameMatch = !res.village_id || villageTrimmed === resVillageTrimmed;

        return bloodGroupMatch && villageNameMatch;
      });
      this.memberList1 = this.MemberList.length;
    })
  }

  goBackToPrevPage() {
    this.location.back();
  }

  searchMember(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.MemberList = this.originalMemberListData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue) ||
        data.contact_no.includes(filterValue);
    });
    this.memberList1 = this.MemberList.length;
  }

  openBottomSheet(): void {
    this._bottomSheet.open(FilterMemberForm, {
      data: this.MemberList,
    });
  }

  ngOnInit(): void {
    this.getAllMember();
    this.getDistrict();
  }

  getAllMember() {
    this.MemberList = [];
    this.originalMemberListData = [];
    this.mainService.getApi(ApiUrls.allMemberList).subscribe((res: any) => {
      if (res.status == 1) {
        if (this.selectedDistrictId) {
          this.MemberList = res.user.filter((a: any) => Number(a.district_id) == Number(this.selectedDistrictId));
        } else {
          this.MemberList = res.user;
        }
        this.memberList1 = this.MemberList.length;
        this.originalMemberListData = res.user;
      }
    });
  }

  getDistrict() {
    this.mainService.getApi(ApiUrls.districtList).subscribe((res: any) => {
      this.dataDistrictList = res.district.filter((x: any) => x.is_active == 1);
    })
  }

  onDistrict_Id(event: any) {
    this.selectedDistrictId = event.target.value;
    this.getAllMember();
  }
}

@Component({
  selector: 'app-filter-member',
  templateUrl: 'filter-member.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterMemberForm implements OnInit {
  dataDistrictList: any = [];
  subdivisionList: any = [];
  villageList: any = [];
  selectedDistrictId: any = 0;
  selectedSubdivisionId: any = 0;
  filter_memberForm: FormGroup;

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FilterMemberForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService,
    private fb: FormBuilder
  ) {
    this.filter_memberForm = this.fb.group({
      blood_group: [''],
      district_name: [''],
      subdivision_name: [''],
      village_name: [''],
      contact_no: [''],
    })

    // for (const key in data) {
    //   const element = data[key];
    //   this.villageList.push(element.village_name);
    // }
    // this.villageList = this.villageList.filter((value: any, index: any, array: any) => array.indexOf(value) === index);
  }
  ngOnInit(): void {
    this.getDistrict()
  }

  getDistrict() {
    this.mainService.getApi(ApiUrls.districtList).subscribe((res: any) => {
      this.dataDistrictList = res.district.filter((x: any) => x.is_active == 1);
    })
  }

  onDistrict_Id(event: any) {
    const selectedDistrictId = event.target.value;
    const selectedDistrict = this.dataDistrictList.find((district: any) => district.district_id == selectedDistrictId);
    this.selectedDistrictId = selectedDistrictId;
    this.getSubdivision(this.selectedDistrictId);
  }

  getSubdivision(id: any) {
    this.mainService.getApi(ApiUrls.subdivisionListSelect + id).subscribe((res: any) => {
      this.subdivisionList = res.subdivision.filter((x: any) => x.is_active == 1);
    });
  }

  onSubdivision_Id(event: any) {
    const selectedSubdivisionId = event.target.value;
    const selectedSubdivision = this.subdivisionList.find((subdivision: any) => subdivision.subdivision_id == selectedSubdivisionId);
    this.selectedSubdivisionId = selectedSubdivisionId;
    this.getVillages(this.selectedSubdivisionId);
  }

  getVillages(id: any) {
    this.mainService.getApi(ApiUrls.villageListSelect + id).subscribe((res: any) => {
      this.villageList = res.village.filter((x: any) => x.is_active == 1);
    });
  }

  Cancel() {
    this._bottomSheetRef.dismiss();
  }

  submit() {
    let data = {
      blood_group: this.filter_memberForm.value.blood_group,
      district_id: this.filter_memberForm.value.district_name,
      subdivision_id: this.filter_memberForm.value.subdivision_name,
      village_id: this.filter_memberForm.value.village_name,
      contact_no: this.filter_memberForm.value.contact_no,
    }
    this.mainService.getFilterData(data);
    this._bottomSheetRef.dismiss();
  }

}
